import React, { Component } from "react";
import "./otica.css";
import Back from "../main/back";
import AppContext from "../appContext";
import Swal from "sweetalert2";
import Form from "react-bootstrap/Form";
import FormCheck from "react-bootstrap/FormCheck";
import UploadLogoOtica from "../main/upload-logo-otica/upload-logo-otica";
import CustomButton from "../components/buttons/button";
import Input from "../components/inputs/input";
import { createLogsOEC } from "../Functions/logs";
import { getClientesReferencial } from "../Functions/empresa/get-clientes-referencial";
import { getAccountData } from "../Functions/account-data/get-account-data";
import CnpjUtils from "../shared/utils/CnpjUtils";
import { LABORATORY_MESSAGES } from "../shared/constants/messages";
class Otica extends Component {
  constructor(props) {
    super(props);

    this.state = {
      labs: [],
      labsPref: [],
      nome_conta: "",
      papel_usuario: "",
      apelido: "",
      nome: "",
      cnpj: "",
      rpl: "",
      hasAccess: false,
      flagApelido: "",
      tipoParticipante:"",
      // Novos estados para a seção Configuração da integração
      integrationTab: "email", // 'email' | 'webhook'
      integrationEmail: "",
      webhookUrl: "",
      webhookSecret: "",
    };

    // novo ref e bind para o indicador das abas
    this.tabsRef = React.createRef();
    this.updateIntegrationIndicator = this.updateIntegrationIndicator.bind(this);

    this.buscarLabs = this.buscarLabs.bind(this);
    this.getOtica = this.getOtica.bind(this);
    this.updateLaboratorioPreferido = this.updateLaboratorioPreferido.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangePreferencia = this.handleChangePreferencia.bind(this);
    this.handleChange = this.handleChange.bind(this);

    Otica.contextType = AppContext;
  }

 async componentDidMount() {
    if (!this.context.userSession?.modulos?.includes("Minha Ótica")) {
      window.location = "/home";
    } else {
      this.context.showLoading("");

      // Busca dados do referencial para obter categoria_cliente_promo (Tipo de Participante)
      const referencialData = await getClientesReferencial(this.context.userSession.conta);

      this.getOtica(this.buscarLabs);

      let tipoParticipante = referencialData?.categoria_cliente_promo || referencialData?.items?.categoria_cliente_promo || "";

      // Fallback: buscar do OEC via get_account_data.php se não encontrou no Referencial
      if (!tipoParticipante) {
        const accountData = await getAccountData(this.context.userSession.conta);
        tipoParticipante = accountData?.tipo || "";
      }

      this.setState({
        papel_usuario: this.context.userSession.papel,
        hasAccess: true,
        tipoParticipante: tipoParticipante
      });
    }
    this.updateIntegrationIndicator();
    window.addEventListener('resize', this.updateIntegrationIndicator);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIntegrationIndicator);
  }

  updateIntegrationIndicator() {
    const tabs = this.tabsRef.current;
    if (!tabs) return;

    // encontra a aba ativa
    const active = tabs.querySelector('.nav-link.active-tab');
    if (!active) {
      // se não houver, zera o indicador
      tabs.style.setProperty('--indicator-left', '0px');
      tabs.style.setProperty('--indicator-width', '0px');
      return;
    }

    const tabsRect = tabs.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    const left = activeRect.left - tabsRect.left;
    const width = activeRect.width;

    tabs.style.setProperty('--indicator-left', `${left}px`);
    tabs.style.setProperty('--indicator-width', `${width}px`);
  }

  getOtica(callback) {
    var session_token = sessionStorage.getItem("session_token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + session_token,
      },
      body: JSON.stringify({ cnpj: this.context.userSession.conta, webhook: true }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_optics.php", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.status === "sucesso") {
          this.setState({
            nome_conta: json.items.nome,
            apelido: json.items.apelido,
            flagApelido: json.items.apelido,
            nome: json.items.nome,
            cnpj: json.items.cnpj,
            integrationEmail: json.items.integrationEmail,
            webhookSecret: json.items.webhookSecret,
            webhookUrl: json.items.webhookUrl,
          });

          if (json.items.laboratoriosPreferidos) {
            this.setState(
              {
                labsPref: json.items.laboratoriosPreferidos.split(";"),
                apelido: json.items.apelido,
                nome: json.items.nome,
                cnpj: json.items.cnpj,
                flagApelido: json.items.apelido,
                integrationEmail: json.items.integrationEmail,
                webhookSecret: json.items.webhookSecret,
                webhookUrl: json.items.webhookUrl,
              },
              callback,
            );
          } else {
            this.setState({ labsPref: [] }, callback);
          }
        }
      });
  }

  buscarLabs() {
    this.context.showLoading("");
    let labsa = [];

    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        cnpjs: this.context.userSession.laboratorios,
        papel: this.context.userSession.papel,
        conta: this.context.userSession.conta,
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_labs.php", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.items) {
          for (var i = 0; i < json.items.length; i++) {
            if (json.items[i].Pedido_c === true) {
              var checked = this.state.labsPref.some(elem => {
                return elem === json.items[i].CNPJ_c;
              });
              var pushObj = {
                nome: json.items[i].Nome_c,
                telefone: json.items[i].Telefone_c,
                site: json.items[i].Site_c,
                email: json.items[i].Email_c,
                cnpj: json.items[i].CNPJ_c,
                logo: json.items[i].URL_Logo_c,
                promo: json.items[i].Promocao_c,
                corteRemoto: json.items[i].RemoteEdge_c,
                detailOrder: json.items[i].DetalhesDoPedido_c,
                IsCor_AR: json.items[i].IsCor_AR_c,
                IsGrowmocao: json.items[i].Growmocao_c,
                checked: json.items[i].IsPreferido ? json.items[i].IsPreferido : false,
                colorirNaOtica: json.items[i].ColorirNaOtica_c ? json.items[i].ColorirNaOtica_c : false,
                // checked: checked,
                link: "/order",
              };
              labsa.push(pushObj);
            }
          }
        }

        if (labsa.length === 0) {
          var empty = {
            nome: LABORATORY_MESSAGES.NO_REGISTRATION_COMPANY,
            link: "/home",
          };
          labsa.push(empty);
        }

        this.setState({
          loading: false,
          labs: labsa,
        });
        this.context.hideLoading();
      });
  }

  handleChangePreferencia(e) {
    const name = e.target.name;
    const value = e.target.value;
    const checked = e.target.checked;

    var listAux = this.state.labsPref;

    if (checked) {
      listAux.push(e.target.value);
    } else {
      listAux = listAux.filter(item => {
        return item !== e.target.value;
      });
    }

    this.setState({ labsPref: listAux });
  }

  updateLaboratorioPreferido() {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        cnpj: this.context.userSession.conta,
        labPreferido: this.state.labsPref.join(";"),
        apelido: this.state.apelido,
        emailNotification: this.state.integrationEmail ? this.state.integrationEmail : null,
        webhookUrl: this.state.webhookUrl ? this.state.webhookUrl : null,
        webhookSecret: this.state.webhookSecret ? this.state.webhookSecret : null,
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "update_optics.php", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.success) {
          this.context.reloadApelido(this.state.apelido);
          Swal.fire({
            text: "Alterações da Empresa realizada com sucesso",
            icon: "success",
            title: "Pronto!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          });
          if (this.state.flagApelido !== this.state.apelido) {
            createLogsOEC(
              this.state.apelido,
              this.state.flagApelido,
              this.context.userSession.email,
              "FRONTEND",
              "ATUALIZAÇÃO DO APELIDO " + this.state.flagApelido + " DA EMPRESA PARA " + this.state.apelido + ". ",
              "ATUALIZAÇÃO",
            );
          }
          this.setState({ flagApelido: this.state.apelido });
        } else {
          Swal.fire({
            text: json.message,
            icon: "error",
            title: "Aviso!",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#00518b",
            confirmButtonText: "Ok!",
          });
        }

        this.context.hideLoading();
      });
  }

  handleSubmit() {

    this.context.showLoading("");
    this.updateLaboratorioPreferido();
  }

  handleChange(e) {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  }

  render() {
    const { nome_conta, papel_usuario } = this.state;
    return !this.state.hasAccess ? (
      <></>
    ) : (
      <main className="main-otica container mt-4">
        <Back items={[{ label: 'Minha Empresa' }]} title="Minha Empresa" />
        <div className="row mt-4 pt-4">
          <div className="col-12 col-lg-4">
            <div className="my-account__info">
              <div className="conecta-h1-container">
                <h1 className="conecta-h1-with-dot">Editar Minha Empresa</h1>
              </div>

              <p className="my-account__paragraph">
                Você está editando as informações da empresa <b>{nome_conta}</b>.
              </p>

              <div className="my-account__menu-anchor">
                <a id="otica-nav-logo" href="#lab_logo">Logo da Empresa</a>
                <a id="otica-nav-apelido" href="#lab_apelido">Informação da Empresa</a>
                {(this.context.userSession.papelCategoria === "OTICA" || this.context.userSession.papelCategoria == "LAB_INDEPENDENTE")
                  && (<a id="otica-nav-lab-pref" href="#lab_pef">Laboratórios de Preferência</a>)}
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="row">
              <div className="col-12 mb-5 pb-5" id="lab_logo">
                <h2 className="order-title">Logo da Empresa</h2>
                <span className="x-web-ordering-pedido__lens intro__form--subtitle title-mobile">
                  Personalize conteúdos para redes sociais adicionando a logo da sua empresa!
                </span>
                <UploadLogoOtica />
              </div>
              <div className="col-12 mt-5 pt-3" id="lab_apelido">
                <h2 className="order-title">Informação da Empresa</h2>
                <span className="x-web-ordering-pedido__lens intro__form--subtitle title-mobile">
                  Informe um apelido para facilitar a identificação da sua Empresa.
                </span>
                <div className="AccordionSummary row">
                  <div className="col-12 col-xl-6 col-lg-6 col-md-6 profileInput">
                    <Input id="otica-empresa" label="Empresa" width="100%" type="text" name="otica" value={this.state.nome} disabled={true} readOnly={true} />
                  </div>
                  <div className="col-12 col-xl-6 col-lg-6 col-md-6 profileInput">
                    <Input
                      id="otica-cnpj"
                      label="CNPJ"
                      width="100%"
                      type="text"
                      name="otica"
                      value={this.state.cnpj ? CnpjUtils.formatCnpj(this.state.cnpj) : ""}
                      disabled={true}
                      readOnly={true}
                    />
                  </div>
                  <div className="col-12 col-xl-6 col-lg-6 col-md-6 profileInput">
                    <Input
                      label="Apelido"
                      width="100%"
                      type="text"
                      name="apelido"
                      value={this.state.apelido}
                      onChange={this.handleChange}
                      placeholder="Empresa sem apelido"
                    />
                  </div>
                  <div className="col-12 col-xl-6 col-lg-6 col-md-6 profileInput">
                    <Input
                      label="Tipo de Participante"
                      width="100%"
                      type="text"
                      name="tipoParticipante"
                      value={this.state.tipoParticipante || ""}
                      disabled={true}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>

              {/* nova seção: somente para LAB_INDEPENDENTE */}
              {this.context.userSession.papelCategoria === "LAB_INDEPENDENTE" && (
                <div className="col-12 mt-5 pt-3" id="lab_integration">
                  <h2 className="order-title">Configuração da integração</h2>
                  <span className="x-web-ordering-pedido__lens intro__form--subtitle title-mobile">
                    Escolha o método de notificação para pedidos realizados no Conecta para o seu laboratório
                  </span>

                  <ul ref={this.tabsRef} className="nav nav-tabs mt-3" role="tablist">
                    <li className="nav-item">
                      <a
                        id="otica-integration-tab-email"
                        role="tab"
                        className={"nav-link " + (this.state.integrationTab === "email" ? "active active-tab" : "")}
                        onClick={() => this.setState({ integrationTab: "email" }, this.updateIntegrationIndicator)}
                      >
                        Notificação via e-mail
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        id="otica-integration-tab-webhook"
                        role="tab"
                        className={"nav-link " + (this.state.integrationTab === "webhook" ? "active active-tab" : "")}
                        onClick={() => this.setState({ integrationTab: "webhook" }, this.updateIntegrationIndicator)}
                      >
                        Notificação via WebHook
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content mt-3">
                    {this.state.integrationTab === "email" && (
                      <div role="tabpanel" className="tab-pane active">
                        <div className="row">
                          <div className="col-12 profileInput">
                            <Input
                              id="otica-integration-email"
                              label="Endereço de e-mail"
                              width="100%"
                              type="email"
                              name="integrationEmail"
                              value={this.state.integrationEmail}
                              onChange={this.handleChange}
                              placeholder="contato@empresa.com.br"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.integrationTab === "webhook" && (
                      <div role="tabpanel" className="tab-pane active">
                        <div className="row">
                          <div className="col-12 profileInput">
                            <Input
                              id="otica-webhook-url"
                              label="Endereço WebHook"
                              width="100%"
                              type="text"
                              name="webhookUrl"
                              value={this.state.webhookUrl}
                              onChange={this.handleChange}
                              placeholder="https://seu-destino.com/webhook"
                            />
                          </div>

                          <div className="col-12 profileInput mt-3">
                            <Input
                              id="otica-webhook-secret"
                              label="Secret WebHook"
                              width="100%"
                              type="text"
                              name="webhookSecret"
                              value={this.state.webhookSecret}
                              onChange={this.handleChange}
                              placeholder="segredo-do-webhook"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(this.context.userSession.papelCategoria === "OTICA" || this.context.userSession.papelCategoria == "LAB_INDEPENDENTE")
                &&
                ((
                <div>
                  <div className=" col-12 mt-5 pt-3" id="lab_pef">
                    <h2 className="order-title">Laboratórios de Preferência</h2>
                    <span className="x-web-ordering-pedido__lens intro__form--subtitle title-mobile">{LABORATORY_MESSAGES.SELECT_PREFERRED_LABS}</span>
                    <Form>
                      <div key={`inline-radio`} className="mb-3 checkboxOne">
                        {this.state.labs.map((item, index) => {
                          return (
                            <Form.Check inline type="checkbox" id={item.nome} className="mt-4">
                              <Form.Check.Input
                                type="checkbox"
                                name={item.nome}
                                value={item.cnpj}
                                defaultChecked={item.checked}
                                bsPrefix="colorInputCheck"
                                onChange={this.handleChangePreferencia}
                              />
                              <Form.Check.Label bsPrefix="colorLabelCheck">
                                {item.link !== "/home" ? <img src={item.logo} alt={item.nome} /> : <p>{item.nome}</p>}
                              </Form.Check.Label>
                            </Form.Check>
                          );
                        })}
                      </div>
                    </Form>
                  </div>
                    <div className="col-12">
                </div>
                  </div>
                ))}
            </div>
            <CustomButton id="otica-save-changes" label="Salvar alterações" disabled={this.state.disabled} onClick={this.handleSubmit} />

          </div>
        </div>
      </main>
    );
  }
}

export default Otica;
